import { Flex, Avatar, Box, Text, Icon } from '@chakra-ui/react';
import { NotificationCard } from '../components/Card';
import { NotificationTime } from '../components/Time';
import IntroRejected from '@/assets/icons/notification/IntroRejected';
import { decode } from 'js-base64';
import { NotificationLink } from '../components/NotificationLink';

export const IntroDeclined = ({ notification = {}, onClose = () => {} }) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));

  return (
    <NotificationCard notification={notification}>
      <Flex>
        <Box>
          <Box height="40px" pos="relative">
            <Avatar
              width="36px"
              height="36px"
              borderRadius="8px"
              className="avatar-md"
              name={data?.requestee_name}
              src={data?.contact_url} // image
            />
            <Box pos="absolute" bottom="-24px" left="9px">
              <Icon as={IntroRejected} width="40px" height="40px" />
            </Box>
          </Box>
        </Box>
        <Box ml="12px">
          <Text>
            <Text as="span" pr="4px" fontWeight="semiBold">
              {data.requestee_name}
            </Text>
            have denied an intro to
            <NotificationLink
              to={`/contacts/${data.contact_id}`}
              label={data.candidate_name}
              onClose={onClose}
              notification={notification}
              data-test-id="candidate-link"
            />
          </Text>
          <NotificationTime notification={notification} />
          <Box mt="8px">
            <Box borderLeft="4px solid #E5E5E5" pl="12px">
              <Text>{notification?.content}</Text>
            </Box>
          </Box>
        </Box>
      </Flex>
    </NotificationCard>
  );
};
